import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule, Optional, SkipSelf } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import * as i2 from '@upr-web-primer/locale';
import { of } from 'rxjs';

const VenueUrls = {
    GET_VENUE_BY_ID: '/Venues/{venueId}',
    GET_VENUE_HOURS_BY_ID: '/Venues/{venueId}/Hours',
};
const BlockoutUrls = {
    GET_PASS_TYPES: '/PassTypes',
    GET_BLOCKOUT_DATES: '/BlockoutDates/{passId}',
};

class UprMobileService {
    constructor(httpClient, localeService, uprMobileServiceConfig) {
        this.httpClient = httpClient;
        this.localeService = localeService;
        this.uprMobileServiceConfig = uprMobileServiceConfig;
    }
    fetchData(url, params) {
        if (!url) {
            return of('URL is not present!!');
        }
        const isApiWithLocaleIssue = url.includes('PointsOfInterest/Shows') ||
            url.includes('ShowsAndAttractions');
        return this.httpClient.get(this.getUrl(this.uprMobileServiceConfig.baseUrl, url), {
            headers: this.getHeaders(isApiWithLocaleIssue),
            params: params,
        });
    }
    fetchVenueHoursById(venueId, endDate, params) {
        const path = this.replaceVenueId(VenueUrls.GET_VENUE_HOURS_BY_ID, venueId);
        const query = endDate ? `?endDate=${endDate}` : '';
        return this.fetchData(path + query, params);
    }
    fetchBlockoutDatesById(passId, endDate, params) {
        const path = BlockoutUrls.GET_BLOCKOUT_DATES.replace('{passId}', passId);
        const query = `?endDate=${endDate}&api-version=1.0`;
        return this.fetchData(path + query, params);
    }
    post(url, body) {
        return this.httpClient.post(this.uprMobileServiceConfig.baseUrl + url, body, {
            headers: this.getHeaders(),
        });
    }
    getHeaders(isApiWithLocaleIssue = false) {
        const locale = this.localeService.getFromStorage();
        const language = locale.language;
        const country = isApiWithLocaleIssue && locale.country === 'cn'
            ? locale.country.toUpperCase()
            : locale.country;
        const httpOptions = new HttpHeaders({
            'X-UNIWebService-ApiKey': this.uprMobileServiceConfig.key,
            'X-UNIWebService-Token': this.uprMobileServiceConfig.token,
            'Accept-Language': `${language}-${country}`,
        });
        return httpOptions;
    }
    replaceVenueId(url, venueId) {
        return url ? url.replace('{venueId}', venueId) : '';
    }
    getUrl(url, path) {
        const urlEndsWithSlash = url[url.length - 1] === '/';
        const pathStartsWithSlash = path.startsWith('/');
        if (urlEndsWithSlash && pathStartsWithSlash) {
            return url + path.substring(1);
        }
        else if (!urlEndsWithSlash && !pathStartsWithSlash) {
            return url + '/' + path;
        }
        return url + path;
    }
}
UprMobileService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UprMobileService, deps: [{ token: i1.HttpClient }, { token: i2.LocaleService }, { token: 'UprMobileServiceConfig' }], target: i0.ɵɵFactoryTarget.Injectable });
UprMobileService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UprMobileService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UprMobileService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.LocaleService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['UprMobileServiceConfig']
                }] }]; } });

class UprMobileServiceModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('GreetingModule is already loaded. Import it in the AppModule only');
        }
    }
    static forRoot(config) {
        return {
            ngModule: UprMobileServiceModule,
            providers: [
                { provide: 'UprMobileServiceConfig', useValue: config },
                UprMobileService,
            ],
        };
    }
}
UprMobileServiceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UprMobileServiceModule, deps: [{ token: UprMobileServiceModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule });
UprMobileServiceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UprMobileServiceModule, imports: [CommonModule] });
UprMobileServiceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UprMobileServiceModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UprMobileServiceModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                }]
        }], ctorParameters: function () { return [{ type: UprMobileServiceModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }]; } });

export { BlockoutUrls, UprMobileService, UprMobileServiceModule, VenueUrls };
